export default {

  computed:{
    
    bot(){
      return this.$store.getters.getBot
    },
    bots() {
      function compare(a, b) {
        if (a.date_Creat > b.date_Creat) return -1;
        if (a.date_Creat < b.date_Creat) return 1;
        return 0;
      }
       
       if(this.$store.getters.getAllBots && this.$store.getters.getAllBots && this.$store.getters.getAllBots.length>0){
       return this.$store.getters.getAllBots.sort(compare);
      }else {
        
      return this.$store.getters.getAllBots
      }
    },
    botsAll() {
      function compare(a, b) {
      if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.bots
        .filter(el => {
          return  el.name.toLowerCase().includes(this.search.toLowerCase())
        })
        .sort(compare);
    },
    filterBySearchBot(){
      function compare(a, b) {
        if (a.date_Creat > b.date_Creat) return -1;
        if (a.date_Creat < b.date_Creat) return 1;
        return 0;
      }
      function compare2(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      function compare1(a, b) {
        if (a.name > b.name) return -1;
        if (a.name < b.name) return 1;
        return 0;
      }
      
      function compare3(a, b) {

        if (a.date_Creat < b.date_Creat) return -1;
        if (a.date_Creat > b.date_Creat) return 1;
        return 0;
      }
      function compare4(a, b) {
        if (a.date_Update > b.date_Update) return -1;
        if (a.date_Update < b.date_Update) return 1;
        return 0;
      }
      function compare5(a, b) {
     
        if (a.date_Update < b.date_Update) return -1;
        if (a.date_Update > b.date_Update) return 1;
        return 0;
      }
      if(this.filterDateUp){
        console.log("########## compare",)
       return this.bots.sort(compare);
     
     }else if(this.filterNameDown){
        console.log("########## compare1", )
        return this.bots.sort(compare1);
     }else if(this.filterNameUp){
       console.log("########## compare2", )
       return this.bots
        .filter(el => {
          return  el.name.toLowerCase().includes(this.search.toLowerCase())
        })
        .sort(compare2);
      // return this.bots.sort(compare2);
     }else if(this.filterDateDown){
        console.log("########## compare3",)
        return this.bots.sort(compare3);
     }else if(this.filterUpdateUp){
        console.log("########## compare4", )
        return  this.bots.sort(compare4);
     }else if(this.filterUpdateDown){
         console.log("########## compare5", )
         return this.bots.sort(compare5);
     }else{
      return this.bots
      .filter(el => {
        return  el.name.toLowerCase().includes(this.search.toLowerCase())
      })
      .sort(compare);
     // return  this.bots.sort(compare)
     }
   
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/mixin.bot.js